import { DanceEventRestrictionDto, DanceEventRulesDto } from '../../..';

export class UpdateDanceEventRulesRequestDto {
  restrictions?: DanceEventRestrictionDto;
  rules?: DanceEventRulesDto;
}
